__turbopack_context__.v({
  "field": "kIqq_q_field",
  "inline": "kIqq_q_inline",
});
